'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { BoardDetailSearchModel } from '@/shared/api/model';
import PcButton from '@/shared/ui/button/PcButton';
import PcNoContents from '@/shared/ui/noContents/PcNoContents';
import { PlusIcon } from '@/shared/ui/svgs';
import Typography from '@/shared/ui/typogrphy/PcTypography';

interface NoticeListItem {
  id: number | undefined;
  category: string;
  title: string;
  date: string | undefined;
}

const NoticeList = ({ notices }: { notices: Array<BoardDetailSearchModel> }) => {
  const t = useTranslations('main.notice');
  return (
    <div className="mt-[40px] border-t border-[#E5E5E5] h-[calc(936px-100px)]">
      {notices && notices.length ? (
        notices.map((notice) => (
          <NoticeListItem
            key={notice.postId}
            id={notice.postId}
            category={notice.isMustRead === 'VPC002' ? t('badge_must_read') : t('badge_notice')}
            title={notice.title || ''}
            date={notice.regDate ? new Date(notice.regDate).toISOString().split('T')[0] : ''} // TODO HJ : 언어별 날짜 포맷 변환
          />
        ))
      ) : (
        <div className="flex justify-center items-center h-full">
          <PcNoContents />
        </div>
      )}
    </div>
  );
};

const NoticeListItem = ({ category, title, date, id }: NoticeListItem) => (
  <Link href={`/customer/notice/${id}`}>
    <div className="flex items-center px-[40px] py-[38px] border-b border-[#E5E5E5] cursor-pointer hover:bg-gray-50">
      <div className="">
        <PcButton
          shape="rectangle"
          variant="outlinePrimary"
          className="rounded-[20px] text-locale-14 font-medium px-[16px]"
        >
          {category}
        </PcButton>
      </div>
      <h3 className="absolute left-[177px] text-locale-20 font-medium text-secondary-black">
        {title}
      </h3>
      <div className="ml-auto">
        <p className="text-locale-18 font-medium text-[#848484]">{date}</p>
      </div>
    </div>
  </Link>
);

const PcBoardNotice = ({ initialNotices }: { initialNotices: Array<BoardDetailSearchModel> }) => {
  const t = useTranslations('main.notice');
  return (
    <section className={'max-w-[1340px] px-[30px] mx-auto h-[936px]'}>
      <div className="relative">
        <div className={'flex justify-between'}>
          <div>
            <Typography variant="heading" className="mb-[16px]">
              {t('title')}
            </Typography>
            <Typography variant="description">{t('sub_title')}</Typography>
          </div>
          <Link href={'/customer/notice#customer-title'}>
            <PcButton
              shape="rectangle"
              variant="outlineDefault"
              width={167}
              height={60}
              className="rounded-[40px] text-locale-18 mt-[56px] font-medium"
            >
              View more
              <PlusIcon color={'black'} size={24} className={'ml-[8px]'} />
            </PcButton>
          </Link>
        </div>
        <NoticeList notices={initialNotices} />
      </div>
    </section>
  );
};

export default PcBoardNotice;
